import {
	Component,
	OnInit,
	ChangeDetectorRef,
	Input,
	EventEmitter,
	Output,
	Inject,
	Optional,
} from "@angular/core";
import { DashboardPorletsService } from "../../dashboardPorlets.service";
import { ApiList } from "../../api";

import { Subscription } from "rxjs";
import { DashboardService } from "../../dashboard.service";
import { cloneDeep, uniqBy } from "lodash";
import { API_SERVICE_TOKEN, PBF_TOKEN } from "../../../service/InjectionToken";
import { getTranslation } from "../../../utils/utils";

@Component({
	selector: "rs-field-filter",
	templateUrl: "./field-filter.component.html",
	styleUrls: ["./field-filter.component.scss"],
})
export class FieldFilterComponent implements OnInit {
	@Input() figureCode;
	@Input() portlet;
	@Input() dashboard;
	@Input() portlets;
	@Output() updatePorletConfig = new EventEmitter();
	public translation;
	public userInfo;
	public userProfile;
	public datePipeFormat;
	public searchText;
	private subscriptions: Subscription[] = [];
	public config;
	public fields = [];
	public fields_copy = [];
	// private tableData_copy = [];
	public tableData = [];
	public showFilter_i;
	public showType_i;
	public showPop_filter: boolean = false;
	public dataType = ["Budget", "Actual", "Forecast", "Rolling"];
	private _portlet;
	public numTypes = ["number", "percent", "percentNum"];
	public childFilterSearchText = "";

	constructor(
		public DashboardPorletsService: DashboardPorletsService,
		private api: ApiList,
		private ref: ChangeDetectorRef,
		private DashboardService: DashboardService,
		@Optional() @Inject(PBF_TOKEN) public pbf: any,
		@Optional() @Inject(API_SERVICE_TOKEN) private http: any,
	) {}

	ngOnInit() {
		this.getInfo();
		this.initFilter();
	}

	ngAfterViewInit(): void {
		this.subscriptions.push(
			this.DashboardService.getportletEdit().subscribe((status) => {
				if (status) {
					this.showPop_filter = false;
					this.showFilter_i = -1;
					this.fields = [];
					this.searchText = "";
					this.initFilter();
					this.ref.markForCheck();
					this.ref.detectChanges();
				}
			})
		);
		this.subscriptions.push(
			this.DashboardService.getPushbtn().subscribe((id) => {
				if (this.dashboard && this.dashboard.id === id) {
					this.initFilter();
					this.ref.markForCheck();
					this.ref.detectChanges();
				}
			})
		);
		this.subscriptions.push(
			this.DashboardService.getclearSidebar().subscribe((status) => {
				if (status) {
					this.fields.forEach((item, index) => {
						if (index !== this.showFilter_i) {
							return;
						}
						item.selectAll = true;
						this.filterSelectAll(true, item);
					});
					this.ref.markForCheck();
				}
			})
		);
	}
	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	private initTableData(field) {
		let columnFilter = [];
		if (this.config.filterSettings.length) {
			const filterSettings = this.config.filterSettings.filter(
				(x) => x.field !== field && x.name !== field
			);
			filterSettings.forEach((setting) => {
				const _field = this.config.fields.find(
					(item) =>
						item.colName === setting.name ||
						item.colName === setting.field
				);
				const Type = _field && _field.dataType;
				if (setting.items) {
					setting.items.forEach((item) => {
						columnFilter.push({
							Field: setting.name,
							Operator: "equal",
							Type,
							// Value:
							// 	Type === "date"
							// 		? moment(item).format("yyyy-MM-DD")
							// 		: Type === "datetime"
							// 		? moment(item).format("yyyy-MM-DD hh:mm:ss")
							// 		: item,
						});
					});
				} else if (setting.Operator || setting.operator) {
					if (setting.operator) {
						setting = {
							Operator: setting.operator,
							Type: setting.type,
							Field: setting.field,
							// Value:
							// 	Type === "date"
							// 		? moment(setting.value).format("yyyy-MM-DD")
							// 		: Type === "datetime"
							// 		? moment(setting.value).format(
							// 				"yyyy-MM-DD hh:mm:ss"
							// 		  )
							// 		: setting.value,
						};
					}
					columnFilter.push(setting);
				}
			});
		}
		if (this.config.portletType === "historicalIRR") {
			columnFilter.push(
				{
					Field: "Frequencys",
					Operator: "equal",
					Type: "string",
					Value: this.config.selectedMultiples,
				},
				{
					Field: "InvestorType",
					Operator: "equal",
					Type: "string",
					Value: this.config.selectedInvestor,
				}
			);
		}
		let data = {
			dashboardDataTableId: this._portlet.dashboardDataTableId,
			displayColumnFilter: field,
			columnFilter,
		};
		if (this.config.portletType === "pivot") {
			data["portletType"] = "pivot";
		}
		return new Promise((resolve, reject) => {
			this.http.post(
				this.api.urlList.GetDistinctColumnValsByPortletDataParam,
				data,
				(res) => {
					resolve(res);
					this.ref.markForCheck();
				}
			);
		});
	}

	// 初始化filter侧边栏，获取当前portlet的filter数据
	private initFilter() {
		this.fields = [];
		this.tableData = [];
		this.fields_copy = [];
		if (this.portlet) this._portlet = cloneDeep(this.portlet);
		if (
			this._portlet &&
			this._portlet.figureCode &&
			this.DashboardPorletsService.getResultByDataTable(
				this._portlet,
				false,
				false,
				this.dashboard.id
			)
		) {
			// 拿到table的数据
			this.tableData = JSON.parse(
				JSON.stringify(
					this.DashboardPorletsService.getResultByDataTable(
						this._portlet,
						false,
						false,
						this.dashboard.id
					)
				)
			);
			// 拿到config和fields的数据
			this.config = JSON.parse(this._portlet.config);
			if (
				this.dashboard &&
				this.DashboardPorletsService.fieldsArr[this.dashboard.id] &&
				this.DashboardPorletsService.fieldsArr[this.dashboard.id][
					this._portlet.figureCode
				]
			) {
				const fields =
					this.DashboardPorletsService.fieldsArr[this.dashboard.id][
						this._portlet.figureCode
					];
				this.fields = [...fields];
			} else {
				this.fields = JSON.parse(JSON.stringify(this.config.fields));
				this.fields.sort((a, b) =>
					a.langValue.toString().localeCompare(b.langValue)
				);
			}
			this.ref.detectChanges();
			if (this.fields && this.fields.length) {
				if (
					!this.config.filterSettings ||
					!this.config.filterSettings.length
				) {
					this.fields.map((el) => {
						el.selectAll = true;
					});
				} else {
					this.fields.map((el) => {
						let attr =
							this.config.portletType == "table"
								? "field"
								: "name";
						let res = this.config.filterSettings.filter(
							(f) => f[attr] === el.colName
						);
						el.selectAll = res.length ? false : true;
					});
				}
			}
			this.fields_copy = JSON.parse(JSON.stringify(this.fields));
			this.fields_copy.forEach((_field) => {
				if (_field.dataList) {
					_field.dataList = [..._field.dataList];
				}
			});
		}
	}

	// search colName
	public filter(filterText: string) {
		this.showFilter_i = -1;
		this.fields = this.fields_copy.filter((el) => {
			// Q2Q名称是拼接addtionName显示，搜索时多判断一个
			const str = filterText.toLocaleLowerCase();
			const itemName = el.addtionName
				? el.langValue + " " + el.addtionName
				: el.langValue;
			return itemName.toLocaleLowerCase().indexOf(str) > -1;
		});
	}

	// click filter icon, 打开filter弹框
	public async openfilter(i, item) {
		let tableData = [];
		this.childFilterSearchText = "";

		if (this.showFilter_i !== i) {
			const res = await this.initTableData(item.colName);
			tableData = (res && res[item.colName]) || [];
			this.pbf.pageLoading = false;
		} else {
			this.showFilter_i = -1;
			this.showPop_filter = !this.showPop_filter;
			return;
		}
		let dataList = [];
		if (tableData && tableData.length) {
			if (item.dataType == "date" || item.dataType == "datetime") {
				tableData = tableData.filter((data) => this.isValidDate(data));
				if (tableData) {
					tableData = tableData.map((item) =>
						this.pbf.formatFilterDate(item)
					);
				}
			}
			if (item.dataType == "number") {
				tableData.forEach((data) => {
					data = this.getNumberPoint(item, data);
				});
			}
			if (item.dataType == "percent" || item.dataType == "percentNum") {
				tableData.forEach((data) => {
					data = this.getPercentPoint(item, data);
				});
			}
			// if (this.numTypes.includes(item.dataType)) {
			// 	this.tableData = uniqBy(this.tableData, item.colName + 1);
			// } else {
			// 	this.tableData = uniqBy(this.tableData, item.colName);
			// }
			// this.tableData = uniqBy(this.tableData, item.colName);
			if (item && item.selectAll) {
				dataList = tableData.map((value) => {
					return {
						value,
						checked: true,
					};
				});
			} else {
				let _filter;
				if (this.config.portletType === "table") {
					const _list = this.config.filterSettings.filter(
						(setting) =>
							setting.name === item.colName ||
							setting.field === item.colName
					);
					if (_list && _list.length) {
						_filter = {
							items: _list.map((_item) => _item.value),
							name: _list[0].field,
							showLabelFilter: false,
							type: "Include",
						};
					}
				} else {
					_filter = this.config.filterSettings.find(
						(setting) =>
							setting.name === item.colName ||
							setting.field === item.colName
					);
				}
				if (_filter && _filter.items && _filter.items.length) {
					let items = _filter.items;
					if (
						item.dataType === "date" ||
						item.dataType === "datetime"
					) {
						items = _filter.items.map((_item) => new Date(_item));
					}
					dataList = tableData.map((value) => {
						return {
							value,
							checked: !!items.find(
								(_item) => String(value) === String(_item)
							),
						};
					});
				}
			}
		}
		// 排序
		if (item.dataType == "date" || item.dataType == "datetime") {
			dataList.sort((a, b) => {
				return new Date(a.value).getTime() < new Date(b.value).getTime()
					? 1
					: -1;
			});
		} else if (item.dataType == "string") {
			dataList.sort((a, b) => a.value.toString().localeCompare(b.value));
		} else if (
			item.dataType == "number" ||
			item.dataType == "percent" ||
			item.dataType == "percentNum" ||
			item.dataType == "multiple"
		) {
			dataList.sort((a, b) => {
				return a.value < b.value ? 1 : -1;
			});
		}
		this.fields[i].dataList = [...dataList];
		this.fields_copy[i].dataList = [...dataList];

		// 判断是否有别的filter弹框已经打开
		if (this.showPop_filter) {
			if (this.showFilter_i === i) {
				this.showPop_filter = false;
			} else {
				this.showPop_filter = true;
			}
		} else {
			this.showPop_filter = true;
		}
		this.showFilter_i = i;
	}
	// filter弹框 - 搜索
	public searchFilter(event, item) {
		let obj = this.fields_copy.find((el) => el.colName == item.colName);

		this.fields_copy.forEach((_field) => {
			if (
				_field.dataList &&
				_field.dataList.length &&
				item.colName === _field.colName
			) {
				const dataList = [..._field.dataList];
				if (
					item.dataType == "string" ||
					item.dataType === "date" ||
					item.dataType === "datetime"
				) {
					item.dataList = dataList.filter(
						(el) =>
							String(el.value)
								.toLocaleLowerCase()
								.indexOf(event.toLocaleLowerCase()) > -1
					);
				} else if (
					item.dataType == "number" ||
					item.dataType == "percent" ||
					item.dataType == "percentNum" ||
					item.dataType == "multiple"
				) {
					item.dataList = dataList.filter(
						(el) => String(el.value).indexOf(event) > -1
					);
				}
				// else if (
				// 	item.dataType === "date" ||
				// 	item.dataType === "dateTime"
				// ) {
				// 	item.dataList = dataList.filter((el) => {
				// 		const val = String(
				// 			item.dataType === "date"
				// 				? moment(el.value).format("yyyy-MM-DD")
				// 				: item.dataType === "datetime"
				// 				? moment(el.value).format("yyyy-MM-DD hh:mm:ss")
				// 				: ""
				// 		);
				// 		return val.indexOf(event) > -1;
				// 	});
				// }
				else {
					item.dataList = dataList.filter(
						(el) => el.value.indexOf(event) > -1
					);
				}
			}
		});

		if (!event || !obj || !obj.dataList || !obj.dataList.length) {
			item.selectAll = obj.selectAll;
			item.dataList = [...obj.dataList];
		}
		// this.tableData = uniqBy(this.tableData, item.colName);

		this.ref.markForCheck();
	}

	// filter弹框 - 点击selectAll
	public filterSelectAll(checked, item) {
		item.dataList.map((el) => (el.checked = checked));
		item.dataList.forEach((data) => {
			this.fields_copy.forEach((field) => {
				if (field.colName == item.colName) {
					field.selectAll = item.selectAll;
					field.dataList.map((copyData) => {
						if (copyData.value == data.value) {
							copyData.checked = data.checked;
						}
					});
				}
			});
		});
		this.getFilterData(item);
	}

	// filter弹框 - 单项勾选状态改变
	public filterChecked(checked, item, value) {
		item.dataList.map((el) => {
			if (el.value == value) el.checked = checked;
		});
		this.checkSelectAll(item);
	}

	// 单项勾选状态改变后，判断是否全部选中或全部未选中
	private checkSelectAll(item) {
		let res = item.dataList.filter((el) => !el.checked);
		if (res.length) {
			item.selectAll = false;
		} else {
			item.selectAll = true;
		}
		item.dataList.forEach((data) => {
			this.fields_copy.forEach((field) => {
				if (field.colName == item.colName) {
					field.selectAll = item.selectAll;
					field.dataList.map((copyData) => {
						if (copyData.value == data.value) {
							copyData.checked = data.checked;
						}
					});
				}
			});
		});
		this.getFilterData(item);
	}

	// 获取filter数据，传值
	private getFilterData(item) {
		let filtervalues = [];
		if (this.config.filterSettings && this.config.filterSettings.length) {
			const filters = [];
			this.config.filterSettings.forEach((setting) => {
				if (
					setting.field === item.colName ||
					setting.name == item.colName
				) {
					return;
				}
				filters.push(setting);
			});
			this.config.filterSettings = [...filters];
		} else {
			this.config.filterSettings = [];
		}
		if (!item.selectAll) {
			let dataList = [];
			let fields_ = this.fields_copy.filter(
				(field) => field.colName == item.colName
			);
			if (item && item.dataList && item.dataList.length) {
				dataList = item.dataList;
			} else {
				dataList = fields_[0].dataList;
			}
			let unChecked = dataList.filter((el) => !el.checked);
			if (unChecked.length !== dataList.length) {
				dataList.forEach((el) => {
					if (el.checked) {
						if (
							this.config.portletType === "table" ||
							this.config.portletType === "transpose"
						) {
							filtervalues.push(el.value);
						} else {
							if (this.numTypes.includes(item.dataType)) {
								if (item.format && item.format.length) {
									let millionNumber = [
										5, 6, 7, 8, 9, 10, 13, 14, 15,
									];
									if (
										millionNumber.includes(
											item.format[0].selectedFormat
										)
									) {
										el.value = el.value / 1000000;
									}
								}
							} else if (
								item.dataType == "date" ||
								item.dataType == "dataTime"
							) {
								el.value = new Date(el.value);
							}
							// filtervalues.push(el.value.toString());
							filtervalues.push(el.value);
						}
					}
				});
			}
			if (filtervalues && filtervalues.length) {
				if (
					this.config.portletType === "table" ||
					this.config.portletType === "transpose"
				) {
					filtervalues.forEach((val) => {
						this.config.filterSettings.push({
							field: item.colName,
							ignoreAccent: false,
							operator: "equal",
							matchCase: false,
							predicate: "or",
							type: item.dataType,
							value:
								item.dataType == "date" ||
								item.dataType == "dataTime"
									? new Date(val)
									: val,
						});
					});
				} else {
					this.config.filterSettings.push({
						name: item.colName,
						type: "Include",
						showLabelFilter: false,
						items: filtervalues,
					});
				}
			} else {
				if (item.dataList && item.dataList.length) {
					if (!item.selectAll) {
						this.config.filterSettings.push({
							items: [],
							name: item.colName,
							showLabelFilter: false,
							type: "Include",
						});
					}
				}
			}
		}

		if (this.config.filterSettings && this.config.filterSettings.length) {
			this.config.filterSettings = uniqBy(
				this.config.filterSettings,
				(el) => el
			);
		}
		// this.config.fields = this.fields_copy;
		this.portlet.config = JSON.stringify(this.config);
		const index = this.portlets.findIndex(
			(x) => x.newId === this.portlet.newId
		);
		if (index > -1)
			this.portlets[index].config = JSON.stringify(this.config);
		this.DashboardPorletsService.filterTriggerGetData(
			this._portlet,
			this.config.filterSettings,
			this.dashboard,
			(res) => {
				this.updatePorletConfig.emit(res);
			}
		);
		this.DashboardService.tableFilter.next(true);
	}

	private getInfo() {
		this.translation = getTranslation()
		this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
		this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
		this.datePipeFormat = localStorage.getItem("datePipe");
	}
	public isValidDate(date) {
		// Invalid date问题，判断是否是有效日期
		// return date instanceof Date && !isNaN(date.getTime())
		let timestamp = Date.parse(date);
		return isNaN(timestamp) ? false : true;
	}

	public getNumberPoint(item, value) {
		if (item.format && item.format.length) {
			let millionNumber = [5, 6, 7, 8, 9, 10, 13, 14, 15];
			let dp = this.getNumberDp(item.format[0].selectedFormat);
			return this.pbf.tofixedNum(
				millionNumber.includes(item.format[0].selectedFormat)
					? value / 1000000
					: value,
				dp
			);
		} else {
			return this.pbf.tofixedNum(value, item.dp);
		}
	}
	private getNumberDp(format) {
		switch (format) {
			case 1:
			case 2:
			case 5:
			case 6:
			case 11:
			case 13:
				return 0;
			case 3:
			case 4:
			case 9:
			case 10:
			case 12:
			case 15:
				return 2;
			case 7:
			case 8:
			case 14:
				return 1;
		}
	}
	private getPercentPoint(item, value) {
		if (item.format && item.format.length) {
			let dp = this.getPercentDp(item.format[0].selectedFormat);
			return (
				this.pbf.tofixedNum(
					item.dataType == "percent" ? value * 100 : value,
					dp
				) + "%"
			);
		} else {
			return this.pbf.tofixedNum(value, item.dp) + "%";
		}
	}
	private getPercentDp(format) {
		switch (format) {
			case 1:
			case 2:
				return 0;
			case 3:
			case 4:
				return 1;
			case 5:
			case 6:
				return 2;
		}
	}
}
